// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__wwR9p","review":"styles_review__Ar2Px","starsContainer":"styles_starsContainer__MyQQV"};